(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaDrug', RcopiaDrug);

    RcopiaDrug.$inject = ['$resource'];

    function RcopiaDrug ($resource) {
        var resourceUrl =  'api/rcopia-drugs/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'findAllByFilter': {url: 'api/rcopia-drugs/filter', method: 'GET', isArray: true},
        });
    }
})();
